import React from 'react';
import FormikSearchDropdown from 'src/components/formik/FormikSearchDropdown/FormikSearchDropdown';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import PropTypes from 'prop-types';
import { catalogueSearchAPI } from 'src/api/CatalogueApi';

const CatalogueVehicleInsuranceDropDown = ({
    value,
    name,
    companyId,
    productId,
    productCategory,
    readOnly,
    disabled,
    ...rest
}) => (
    <FormikSearchDropdown
        name={name}
        placeholder="Select Catalogue"
        displayKeyPath={[
            'catalogueName',
            'meta.cubicCapacity',
            'meta.vehicleStatus',
            'meta.vehicleInsuranceInterestRate',
        ]}
        valueKeyPath="_id"
        defaultValueFetchByKeyPath="_id"
        whereClauseKeysPaths={[
            'catalogueName',
        ]}
        api={catalogueSearchAPI}
        apiCallAddonData={{
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
        }}
        value={value}
        whereConditions={{
            companyId,
            productId,
            productCategory,
        }}
        disabled={
            !companyId
            || !productId
            || !productCategory
            || readOnly
            || disabled
        }
        {...rest}
    />
);

CatalogueVehicleInsuranceDropDown.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
    companyId: PropTypes.string,
    productId: PropTypes.string,
    productCategory: PropTypes.string,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
};

CatalogueVehicleInsuranceDropDown.defaultProps = {
    value: '',
    companyId: '',
    productId: '',
    productCategory: '',
    readOnly: false,
    disabled: false,
};

export default CatalogueVehicleInsuranceDropDown;
